
import ItineraryList from "../ItineraryList";
import SelectedItinerary from "../SelectedItinerary";
import LoginForm from "../../../LoginPage/Components/LoginForm";
import SignupForm from "../../../LoginPage/Components/SignupForm";
import TrendsPage from "./TrendsPage";
import { useState, useEffect } from "react";

import { fetchHighlightedItinerariesOfAgent, fetchItineraryById } from "../../../../services/agentServices";
import ItineraryPreviewerPlus from "./ItineraryPreviewerPlus";

const PublicItineraries = (props) => {

    const params = new URLSearchParams(window.location.search);

    const {
        bookingEngine,
        selectedItinerary, 
        setSelectedItinerary
    } = props;

    const [ highlightedItineraries, setHighlightedItineraries ] = useState([]);

    useEffect(()=>{
        (async()=>{
            let _agent_id = "";
            if(localStorage.getItem("agent")){
                _agent_id = localStorage.getItem("agent");
            }
            if(params.has("itin_id") && params.get("itin_id")){
                let _itin_id = params.get("itin_id");
                const _res = await fetchItineraryById(_itin_id);
                if(_res?._id)
                    setSelectedItinerary(_res);
            }else{
                let _itin_res = await fetchHighlightedItinerariesOfAgent(_agent_id, {});
                if(Array.isArray(_itin_res)){
                    setHighlightedItineraries(_itin_res);
                }
            }
        })()
    }, []);

    const {
        packageTrendsShowHomePage,
    } = bookingEngine;

    return <div>
        {
            selectedItinerary?._id ?
            <ItineraryPreviewerPlus 
                pageTheme={bookingEngine}
                selectedItinerary={selectedItinerary}
                onBack={()=>setSelectedItinerary({})}
            /> :
            <>
                {
                    packageTrendsShowHomePage &&
                    <TrendsPage
                        highlightedItineraries={highlightedItineraries}
                        bookingEngine={bookingEngine}
                        setSelectedItinerary={setSelectedItinerary}
                    />
                }
            </>
        }
    </div>
}

export default PublicItineraries;